import { redirect } from 'react-router';
import { publicAction } from '@/data/loaders';

export function updateProfile(params) {
  return publicAction("updateProfile", params, { allowIncompleteUserdata: true })
}

export function getMyOrganizationDepartments() {
  return publicAction("getMyOrganizationDepartments", {}, { allowIncompleteUserdata: true })
}

export function requestToJoinDepartment({ id }) {
  return publicAction("requestToJoinDepartment", { id }, { allowIncompleteUserdata: true })
}

export function loadSettings({request}) {
  return new Promise(function (resolve, reject) {
    if (request.url.endsWith("/settings") || request.url.endsWith("/settings/")) {
      resolve(redirect("/settings/profile"));
    } else {
      resolve({});
    }
  })
}